import { API_URLS } from "../apiUrls";

export const CUSTOMER_SURVEY_TOKEN =
  "QVJleU5pcXRER2E4bzhoY0JiTWprZFYyRmFUK0VNRnEyMG1sL3ZGWjJFWXd2TGNTRDYzeWhCTnF1RTNvWnlnaXhpMVp5ZktRek9jcFJPUTAxcnZWU3c9PQ";

export const customerSurveyUnitTestsConstants = {
  NEXT_BUTTON_NAME: "NEXT",
  BACK_BUTTON_NAME: "BACK",
  SUBMIT_BUTTON_NAME: "SUBMIT",
  QUESTION_TEXT_LABEL: "question-text",
  PREVIEW_SURVEY_PAGE_ROUTE: "/preview-survey?isPOSQuestion=false",
  CUSTOMER_SURVEY_PAGE_ROUTE: `/customer-survey/${CUSTOMER_SURVEY_TOKEN}`,
  GET_SURVEY_API_URL: `${API_URLS.SURVEY.CUSTOMER}/${CUSTOMER_SURVEY_TOKEN}`,
};
